import { useCallback, useEffect, useState } from 'react';

export default function useYouTubeConnection(siteId) {
  const [status, setStatus] = useState({
    connected: false,
    needs_reauth: false,
    last_error: null,
    last_error_at: null,
  });

  const refresh = useCallback(async () => {
    if (!siteId) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await fetch(`/api/youtube/status?site=${encodeURIComponent(siteId)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      setStatus({
        connected: !!data.connected,
        needs_reauth: !!data.needs_reauth,
        last_error: data.last_error || null,
        last_error_at: data.last_error_at || null,
      });
    } catch (err) {
      console.error('Failed to fetch YouTube status', err);
    }
  }, [siteId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const connect = useCallback(async () => {
    if (!siteId) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    const returnParams = new URLSearchParams({
      siteId: String(siteId),
      tab: 'Settings',
      settingsSubTab: 'Integrations',
      oauth: 'youtube',
    });
    const returnTo = `/control-panel?${returnParams.toString()}`;
    const authParams = new URLSearchParams({
      site: String(siteId),
      returnTo,
    });
    const res = await fetch(`/api/youtube/auth-url?${authParams.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return;
    const data = await res.json();
    if (data?.authUrl) {
      window.open(data.authUrl, '_blank');
    }
  }, [siteId]);

  const disconnect = useCallback(async () => {
    if (!siteId) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await fetch('/api/youtube/disconnect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ site: siteId }),
      });
      if (res.ok) {
        setStatus({
          connected: false,
          needs_reauth: false,
          last_error: null,
          last_error_at: null,
        });
      }
    } catch (err) {
      console.error('Failed to disconnect YouTube', err);
    }
  }, [siteId]);

  return { status, refresh, connect, disconnect };
}
